import { IoDocumentTextOutline } from "react-icons/io5";

import { CodeBlock } from "./CodeBlock";
import { InvisibleRow, SECTION_LABEL } from "./InvisibleRow";

interface SystemPromptCardProps {
  content: string;
  metadata?: Record<string, any>;
  createdAt?: string;
}

/**
 * The full instructions the bot was given. Collapsed to the shared
 * {@link InvisibleRow} pill; the prompt body (and its per-section breakdown,
 * when the metadata carries one) sits behind the expand.
 */
export function SystemPromptCard({ content, metadata, createdAt }: SystemPromptCardProps): React.ReactElement {
  const meta = metadata || {};

  return (
    // Admin-tier row (ADMIN_ONLY_MESSAGE_TYPES), hence the purple fill.
    <InvisibleRow
      icon={<IoDocumentTextOutline size={16} />}
      label={`System prompt · ${content.length.toLocaleString()} chars`}
      createdAt={createdAt}
      tone="purple"
    >
      {meta.sections?.map((section: any) => (
        <div key={section.id} className="mb-2 flex items-center gap-2">
          <p className={SECTION_LABEL}>{section.id}</p>
          <span className="body-mono text-grey-600">{section.length?.toLocaleString()} chars</span>
        </div>
      ))}
      {!meta.sections && meta.staticContent && (
        <div className="mb-3">
          <p className={SECTION_LABEL}>Static (Cached)</p>
          <CodeBlock>{meta.staticContent}</CodeBlock>
        </div>
      )}
      {!meta.sections && meta.dynamicContent && (
        <div>
          <p className={SECTION_LABEL}>Dynamic (Per-call)</p>
          <CodeBlock>{meta.dynamicContent}</CodeBlock>
        </div>
      )}
      {!meta.sections && !meta.staticContent && !meta.dynamicContent && <CodeBlock>{content}</CodeBlock>}
      {meta.sections && <CodeBlock>{content}</CodeBlock>}
    </InvisibleRow>
  );
}
